import { useGetCamperInfoQuery } from "../store/account/api";
import { useDispatch, useSelector } from "react-redux";
import {useEffect} from "react";
import {uiActions} from "../store/ui/slice";

const useCamperInfo = () => {
  const customerId = useSelector((state) => state.auth.customerId);
  const programType = useSelector((state) => state.account.programType);
  //const programType = 25; //C-Cats Middle School (for testing)
  //const programType = undefined;
  const skip = !customerId;
  const dispatch = useDispatch();

  const {
    data: camperInfo,
    error: camperError,
    isFetching: isFetchingCamperInfo,
    isSuccess: isSuccessCamperInfo,
    isError: isErrorCamperInfo,
    refetch,
  } = useGetCamperInfoQuery({ customerId, programType }, { skip });
  //programType should be "Summer Camp", "C-CATS", or ""

  useEffect(() => {
    //clear old admin messages first to be sure old ones aren't saved in the redux store
    dispatch(uiActions.clearAdminMessages());

    if (isSuccessCamperInfo) {
      camperInfo.forEach((camper) => {
        if (camper.sessions) {
          camper.sessions.forEach((session) => {
            if (session.adminMessage) {
              dispatch(uiActions.addAdminMessage({text: session.adminMessage, isOpen: true}));
            }
          });
        }
        if (camper.adminMessages){
          camper.adminMessages.forEach((message) => {
            dispatch(uiActions.addAdminMessage({text: message, isOpen: true}));
          });
        }
      });
      //reopen all messages each time the camper info is fetched
      dispatch(uiActions.reopenAllAdminMessages());
    }
  }, [camperInfo, isSuccessCamperInfo, dispatch]);

  return {
    camperInfo,
    camperError,
    isFetchingCamperInfo,
    isErrorCamperInfo,
    isSuccessCamperInfo,
    refetch,
  };
};

export default useCamperInfo;
